// ============================================================================
// ENQUIRY EMAIL SETUP (EmailJS)
// ============================================================================
// The enquiry form uses EmailJS (https://www.emailjs.com) to send the
// submitted enquiry straight to your inbox — no backend/server required.
//
// Setup (takes ~5 minutes, free plan is enough for most small businesses):
//   1. Create a free account at https://www.emailjs.com
//   2. Add an Email Service (e.g. connect your Gmail) -> copy the "Service ID"
//   3. Create an Email Template with these variables in the template body:
//        {{from_name}}, {{from_contact}}, {{message}}, {{branch_info}}
//      -> copy the "Template ID"
//      Set the template's "To email" to the address you want enquiries sent to
//      (e.g. ks@infotechks.com)
//   4. Go to Account -> General -> copy your "Public Key"
//   5. Paste all three values below.
//
// Until these are filled in, the enquiry form will still work in the UI
// (the GST numbers will still unlock after submitting) but the email will
// not actually be delivered — check the browser console for a warning.
// ============================================================================

const emailConfig = {
  SERVICE_ID: 'service_crsv6ia',
  TEMPLATE_ID: 'template_vppkvxc',
  PUBLIC_KEY: 'mP3t4zNdTuGj_w4VL',
};

export const isEmailConfigured = () =>
  Boolean(
    emailConfig.SERVICE_ID &&
    emailConfig.TEMPLATE_ID &&
    emailConfig.PUBLIC_KEY
  );

export default emailConfig;



// const emailConfig = {
//   SERVICE_ID: 'service_crsv6ia',
//   TEMPLATE_ID: 'template_vppkxxc',
//   PUBLIC_KEY: 'mP3t4zNdTuGj_w4VL',
// };

// export const CLIENT_EMAIL = "ks@infotechks.com";

// export const isEmailConfigured = () =>
//   emailConfig.SERVICE_ID === 'service_crsv6ia' &&
//   emailConfig.TEMPLATE_ID === 'template_vppkxxc' &&
//   emailConfig.PUBLIC_KEY === 'mP3t4zNdTuGj_w4VL';

// export default emailConfig;
